import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function MobileShell({
  children,
  header = true,
  title,
  hideBack,
  action,
  transparent = false,
}) {
  const navigate = useNavigate();
  return (
    <div className="resqly-shell">
      <div className="resqly-frame flex flex-col min-h-screen min-h-[100dvh]">
        {header && (
          <div
            className={cn(
              'sticky top-0 z-30 px-4 py-3 flex items-center justify-between',
              transparent
                ? 'bg-transparent'
                : 'bg-white/90 backdrop-blur-md border-b border-[var(--resqly-border)]',
            )}
            style={{ paddingTop: 'max(12px, env(safe-area-inset-top))' }}
          >
            <div className="flex items-center gap-2 min-w-0">
              {!hideBack && (
                <button
                  data-testid="shell-back"
                  onClick={() => navigate(-1)}
                  className="p-2 -ml-1 rounded-xl hover:bg-slate-100 active:scale-95 transition-transform"
                  aria-label="Go back"
                >
                  <ChevronLeft className="w-5 h-5 text-slate-700" />
                </button>
              )}
              <div className="font-semibold text-slate-900 truncate">{title}</div>
            </div>
            <div className="flex-shrink-0">{action}</div>
          </div>
        )}
        <div className="flex-1 min-h-0">{children}</div>
      </div>
    </div>
  );
}
